// Where the user came from before opening a product card, so the card can offer
// "← Назад · <that page>" and return to it with its filters. AppShell records every non-product
// route; sessionStorage keeps it across a reload of the card itself.

const KEY = "wa_back_route";

const LABELS: Array<[RegExp, string]> = [
  [/^\/$/, "Обзор"],
  [/^\/report\/current/, "Текущий остаток"],
  [/^\/report\/daily/, "По дням"],
  [/^\/report\/weekly/, "По неделям"],
  [/^\/report\/monthly/, "По месяцам"],
  [/^\/all-reports/, "Все отчёты"],
  [/^\/reconciliation/, "Расхождения"],
  [/^\/alerts/, "Проблемы"],
  [/^\/settings/, "Настройки"],
];

export const FALLBACK_BACK = { path: "/report/current", label: "Текущий остаток" };

export function rememberRoute(pathname: string, search: string): void {
  if (pathname.startsWith("/product/") || pathname === "/login") return;
  try {
    sessionStorage.setItem(KEY, pathname + search);
  } catch {
    /* storage blocked — the card falls back to Текущий остаток */
  }
}

export function backRoute(): { path: string; label: string } {
  let path: string | null = null;
  try {
    path = sessionStorage.getItem(KEY);
  } catch {
    /* ignore */
  }
  if (!path) return FALLBACK_BACK;
  const label = LABELS.find(([re]) => re.test(path!.split("?")[0]))?.[1];
  return label ? { path, label } : FALLBACK_BACK;
}

// The route right before the current one (any route), so the card can tell whether a plain
// browser "back" lands exactly on the page it names — then it uses history (restores scroll and
// table position); otherwise it navigates to that page.
let current: string | null = null;
let previous: string | null = null;

export function trackRoute(pathname: string, search: string): void {
  const full = pathname + search;
  if (full === current) return;
  previous = current;
  current = full;
  rememberRoute(pathname, search);
}

export function previousRoute(): string | null {
  return previous;
}
